import {configureStore} from '@reduxjs/toolkit';
import rootReducer from './reducers/root';
import {listenerMiddleware} from 'core/middleware/listenerMiddleware';
import {apiSlice} from 'core/services/ApiSlice';
import {reportsApiSlice} from 'core/services/ReportsApiSlice';
import {gridReportsApiSlice} from 'core/services/GridReportsApiSlice';
import {useSelector} from "react-redux";
import {bookmarksApiSlice} from "core/services/BookmarkApiSlice";


const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware(
      {
        serializableCheck: {
          // Ignore these action types
          ignoredActions: [
            'pbiReport/setReport',
            'pbiReportSlice/setReport',
          ],
          // Ignore these paths in the state
          ignoredPaths: [
            'pbiReport.report',
            'pbiReportSlice.report'
          ],
        },
      }
    )
      .prepend(listenerMiddleware.middleware)
      .concat(apiSlice.middleware, reportsApiSlice.middleware, gridReportsApiSlice.middleware, bookmarksApiSlice.middleware),
});

if (module.hot && process.env.NODE_ENV === 'development') {
  module.hot.accept('./reducers/root', () => store.replaceReducer(rootReducer));
}


export const useAppSelector = useSelector.withTypes<RootState>();
export type RootState = ReturnType<typeof rootReducer>;


export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
// export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;




